'use strict'

import AccessLogRepository from './AccessLogRepository'
import AdminRepository from './AdminRepository'
import AgentRepository from './AgentRepository'
import AnnouncementRepository from './AnnouncementRepository'
import AppSuiteJobRepository from './AppSuiteJobRepository'
import AttachmentRepository from './AttachmentRepository'
import AttachsizeSettingRepository from './AttachsizeSettingRepository'
import AuthRepository from './AuthRepository'
import BcardRepository from './BcardRepository'
import BcardImageRepository from './BcardImageRepository'
import BcIndexRepository from './BcIndexRepository'
import DisplaySettingRepository from './DisplaySettingRepository'
// import EditcorpsRepository from './EditcorpsRepository'
// import EditpostetcRepository from './EditpostetcRepository'
import ExchangeRepository from './ExchangeRepository'
import ExlocationRepository from './ExlocationRepository'
import ExpireSettingRepository from './ExpireSettingRepository'
import ExtriggerRepository from './ExtriggerRepository'
import FavoriteRepository from './FavoriteRepository'
import FileRepository from './FileRepository'
import GroupRepository from './GroupRepository'
import ImageRepository from './ImageRepository'
import InfoRepository from './InfoRepository'
import InputProxySettingsRepository from './InputProxySettingsRepository'
import LibRepository from './LibRepository'
import LicenseSettingRepository from './LicenseSettingRepository'
import MbLoginSettingRepository from './MbLoginSettingRepository'
import ManageBcardRepository from './ManageBcardRepository'
import ManagePersonRepository from './ManagePersonRepository'
import MergePersonRepository from './MergePersonRepository'
import MgTagRepository from './MgTagRepository'
import MobileSettingRepository from './MobileSettingRepository'
import NeoConnectionRepository from './NeoConnectionRepository'
import NewBcardRepository from './NewBcardRepository'
import NoImageRepository from './NoImageRepository'
import NisfaIntegrationRepository from './NisfaIntegrationRepository'
import PasswordPolicyRepository from './PasswordPolicyRepository'
import PersonalDataRepository from './PersonalDataRepository'
import PersonRepository from './PersonRepository'
import PvPinRepository from './PvPinRepository'
import ProfileSettingRepository from './ProfileSettingRepository'
import PvNisfaIntegrationRepository from './PvNisfaIntegrationRepository'
import PvtagRepository from './PvtagRepository'
import SearchRepository from './SearchRepository'
import TagRepository from './TagRepository'
import TopRepository from './TopRepository'
import UserRepository from './UserRepository'
import UserSettingRepository from './UserSettingRepository'
import InformationSettingsRepository from './InformationSettingsRepository'

// TODO 使わないリポジトリまでインスタンス化しているので、get()した時点でnewした方がメモリ効率がよいのでは？
const repositories = {
  // 並びをspecに合わせています
  //
  // ---------- 一般 ----------
  authority: new AuthRepository(), // 含：login、password
  top: new TopRepository(),
  info: new InfoRepository(),
  // password: AuthRepositoryに記載
  file: new FileRepository(),
  search: new SearchRepository(),
  favorite: new FavoriteRepository(),
  newbcard: new NewBcardRepository(),
  bimage: new BcardImageRepository(),
  bcindex: new BcIndexRepository(),
  person: new PersonRepository(),
  attachment: new AttachmentRepository(),
  bcard: new BcardRepository(),
  exchange: new ExchangeRepository(),
  //
  // ---------- メンテナンス ----------
  mergeperson: new MergePersonRepository(),
  noimage: new NoImageRepository(),
  personaldata: new PersonalDataRepository(),
  //
  // ---------- 機能管理 ----------
  managebcard: new ManageBcardRepository(),
  manageperson: new ManagePersonRepository(),
  // editcorps: new EditcorpsRepository(),
  // editpostetc: new EditpostetcRepository(),
  //
  // ---------- 個人設定 ----------
  agents: new AgentRepository(),
  dcsettings: new DisplaySettingRepository(),
  pin: new PvPinRepository(),
  pvtag: new PvtagRepository(),
  mbcsettings: new MobileSettingRepository(),
  profiles: new ProfileSettingRepository(),
  pvnisfaintegration: new PvNisfaIntegrationRepository(),
  //
  // ---------- システム管理者設定 ----------
  admin: new AdminRepository(),
  announcement: new AnnouncementRepository(),
  attachsizesettings: new AttachsizeSettingRepository(),
  user: new UserRepository(),
  usersetting: new UserSettingRepository(),
  group: new GroupRepository(),
  mgtag: new MgTagRepository(),
  tag: new TagRepository(), // mgtagとpvtagの共通API
  extrigger: new ExtriggerRepository(),
  exlocation: new ExlocationRepository(),
  inputproxysettings: new InputProxySettingsRepository(),
  infosettings: new InformationSettingsRepository(),
  expiresettings: new ExpireSettingRepository(),
  mbloginsettings: new MbLoginSettingRepository(),
  accesslogs: new AccessLogRepository(),
  passwordpolicy: new PasswordPolicyRepository(),
  licenses: new LicenseSettingRepository(),
  nisfaintegration: new NisfaIntegrationRepository(),
  neoconnection: new NeoConnectionRepository(),
  appsuitejob: new AppSuiteJobRepository(),
  //
  // ---------- その他 ----------
  image: new ImageRepository(),
  lib: new LibRepository()
}

export default {
  get (name) {
    return repositories[name]
  }
}



// WEBPACK FOOTER //
// ./src/repositories/RepositoryFactory.js